module.exports = __webpack_public_path__ + "img/2-2.2d3f4c51.png";